import React from 'react'
import 'antd/dist/antd.css';
import { PAGE_COMPANY, PAGE_LINK } from '../../config'
import Top from '../../components/common/Top'
import Footer from '../../components/common/Footer'
import { Layout, Input, Button, Row, Col, Typography, Spin, message, Modal } from 'antd';

import actionWays from "../../redux/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import homeImg from '../../assets/images/home-bg2.png'
const { Title } = Typography;
class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <Layout style={{ minHeight: '100%', minWidth: '100%' }} id='homeId'>
                {/* <Top getQualificationList={this.getQualificationList} getQueryProgressList={this.getQueryProgressList} getURL={this.getURL} /> */}
                <Layout style={{ width: '100vw', height: '80vh' }}>
                    {/* <img className='img' src={homeImg} ></img> */}
                    <div className="homeTop">
                        <div className="col-lg-2"></div>
                        <div className="col-lg-8">
                            <div className="content">
                                <Title level={1} style={{ marginBottom: '0', }}>
                                    <p>尊敬的各位用户：</p>
                                    {/* <p>大家好！</p> */}
                                    <p style={{ lineHeight: '2em', marginTop: '-15px',textIndent:'2em' }}>因系统升级，相关服务将在2023年12月28日18:00至2024年1月2日8:00期间停止服务，2024年1月2日8:00起恢复服务，给您带来不便，敬请谅解。
                                    后续请登录住房保障信息系统跳转进入公租房网签系统，住房保障信息系统登录地址如下:<br/>
                                        USB-KEY登录地址为：<a href='https://zfbzpt.fgj.sh.gov.cn:2001/shzb_platform/tyrk/USBLogin.jsp' target='_blank'>https://zfbzpt.fgj.sh.gov.cn:2001/shzb_platform/tyrk/USBLogin.jsp</a><br/>
                                        用户名密码登录地址为：<a href='https://zfbzpt.fgj.sh.gov.cn:2001/shzb_platform/tyrk/Login.jsp' target='_blank'>https://zfbzpt.fgj.sh.gov.cn:2001/shzb_platform/tyrk/Login.jsp</a>
                                    </p>
                                </Title>

                            </div></div>
                        <div className="col-lg-2"></div>
                    </div>

                </Layout>
                {/* <Footer /> */}
            </Layout>
            // <Layout style={{ minHeight: '100%', minWidth: '100%' }} id='homeId'>
            //     <Layout style={{ width: '100vw', height: '80vh' }}>
            //         <img className='img' src={homeImg} ></img>
            //         <div className="homeTop">
            //             <div className="col-lg-2"></div>
            //             <div className="col-lg-8">
            //                 <div className="content">
            //                     <Title level={1} style={{ marginBottom: '0', }}>
            //                         <p>尊敬的各位用户：</p>
            //                         <p style={{ lineHeight: '2em', marginTop: '-15px' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您好，为了给您带来更好地使用体验，临港新片区人才安居网及小程序将于9月28日 17:00 - 10月7日
			// 8:00期间进行例行维护，维护期间在线申请及在线支付功能暂停，且无法正常浏览网站相关内容，维护期间给您带来不便，敬请谅解，感谢您长期的支持与关注！<br/>
            //                             </p>
            //                         <p style={{ float: 'right',lineHeight:'1.8em', marginTop: '-30px' }}>{PAGE_COMPANY}</p>
            //                         <p style={{clear:'both'}}></p>
            //                         <p style={{ float: 'right',lineHeight:'1.8em', marginTop: '-60px' }}>2023年9月28日</p>
            //                     </Title>

            //                 </div></div>
            //             <div className="col-lg-2"></div>
            //         </div>

            //     </Layout>
            // </Layout>
        )
    }
    tableBody = (item, index) => {
        return (
            <li key={index}>
                <span className="username">
                    {item.username}
                </span>
                <span className="telephone">
                    {item.transactionNo}
                </span>
            </li>
        );
    }
    getQualificationList = () => {
        this.refs.qualification.showQualification()
    }
    getQueryProgressList = () => {
        this.refs.queryProgress.showQueryProgress()
    }
}
const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home))
